<style src="./ColumnHeader.scss" lang="scss"></style>
<template>
  <tr class="column-header">
    <th scope="row" class="header id">
      <div class="filtered">
        <span class="title titleinfo">ITEM</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.number.filterValue.length > 0
          }"
          @click.stop="toggleContextPopup('number')"
          class="optionalmenu"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.number"
          @close="toggleContextPopup('number', false)"
          position="right"
        >
          <context-list-filter
            title="Item"
            columnId="number"
            :active-options="activeFilter.number.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header quotesmap" title="Cotações">
      <div class="filtered">
        <span class="title titleinfo">COTA</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.quotationMap.filterValue.length < 5
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('quotationMap')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.quotationMap"
          @close="toggleContextPopup('quotationMap', false)"
          position="right"
        >
          <quotes-map-context-filter
            title="Cotações"
            columnId="quotationMap"
            :active-options="activeFilter.quotationMap.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header strict" title="Exclusivo para ME">
      <div class="filtered">
        <span class="title titleinfo">ME</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.strictToME.filterValue.length < 2
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('strictToME')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.strictToME"
          @close="toggleContextPopup('strictToME', false)"
          position="right"
        >
          <context-me-filter
            title="Restrição para Micro Empresa"
            columnId="strictToME"
            :active-options="activeFilter.strictToME.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header guaranted" title="Produto com garantia de preço">
      <div class="filtered">
        <span class="title titleinfo">
          <icon-star class="icon" />
        </span>
        <div
          :class="{
            dottedmenu__active:
              activeFilter.isPriceGuaranted.filterValue.length < 2
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('isPriceGuaranted')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.isPriceGuaranted"
          @close="toggleContextPopup('isPriceGuaranted', false)"
        >
          <context-guaranted-filter
            title="Garantia de preço"
            columnId="isPriceGuaranted"
            :active-options="activeFilter.isPriceGuaranted.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header product">
      <div class="filtered">
        <span class="title titleinfo">DESCRIÇÃO</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.description.filterValue.length > 0
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('description')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="350px"
          v-if="visibleContextMenu.description"
          @close="toggleContextPopup('description', false)"
          position="left"
        >
          <context-list-filter
            title="Descrição"
            columnId="description"
            :active-options="activeFilter.description.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header qt">
      <div class="filtered">
        <span class="title titleinfo">UNID</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.unity.filterValue.length > 0
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('unity')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.unity"
          @close="toggleContextPopup('unity', false)"
        >
          <context-list-filter
            title="Unidade"
            columnId="unity"
            :active-options="activeFilter.unity.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header qt">
      <span class="htitle">QT</span>
    </th>

    <!-- COST -->
    <th
      @click="toggleColumnView('costLab')"
      :class="{ lab__contracted: headerView.contracted.costLab }"
      class="header lab"
    >
      <div class="filtered">
        <span class="title unit">MARCA</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.costLab.filterValue.length > 0
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('costLab')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.costLab"
          @close="toggleContextPopup('costLab', false)"
        >
          <context-list-filter
            title="Empresas"
            columnId="costLab"
            :active-options="activeFilter.costLab.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('costUnit')"
      :class="{ unit__contracted: headerView.contracted.costUnit }"
      class="header unit"
    >
      <div class="filtered">
        <span class="title unit">V. UNIT</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.costUnit.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('costUnit')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.costUnit"
          @close="toggleContextPopup('costUnit', false)"
        >
          <context-text-filter
            columnId="costUnit"
            :active-options="activeFilter.costUnit.filterValue"
            :active-type="activeFilter.costUnit.filterType"
            @clean-filter="cleanFilter"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('costTotal')"
      :class="{ total__contracted: headerView.contracted.costTotal }"
      class="header total separator"
    >
      <div class="filtered">
        <span class="title unit">V. TOTAL</span>
        <div class="monitortotal" :style="{ top: headerView.totalTopPosition }">
          <span class="title">TOTAL</span>
          <span class="label"
            ><small>R$</small>
            {{ totalGlobal.totalCost | CurrencyBR("0,00") }}</span
          >
        </div>
        <div
          :class="{
            dottedmenu__active: activeFilter.costTotal.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('costTotal')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.costTotal"
          @close="toggleContextPopup('costTotal', false)"
        >
          <context-text-filter
            columnId="costTotal"
            :active-options="activeFilter.costTotal.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>

    <!-- CMED PRICE -->
    <th
      @click="toggleColumnView('maxLab')"
      :class="{ lab__contracted: headerView.contracted.maxLab }"
      class="header lab"
    >
      <div class="filtered">
        <span class="title unit">MARCA</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.maxLab.filterValue.length > 0
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('maxLab')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.maxLab"
          @close="toggleContextPopup('maxLab', false)"
        >
          <context-list-filter
            title="Empresas"
            columnId="maxLab"
            :active-options="activeFilter.maxLab.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('maxUnit')"
      :class="{ unit__contracted: headerView.contracted.maxUnit }"
      class="header unit"
    >
      <div class="filtered">
        <span class="title unit">V. UNIT</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.maxUnit.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('maxUnit')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.maxUnit"
          @close="toggleContextPopup('maxUnit', false)"
        >
          <context-field-compare
            columnId="maxUnit"
            :active-options="activeFilter.maxUnit.filterValue"
            @filter-value="filterColumn"
          />
          <context-text-filter
            columnId="maxUnit"
            :active-options="activeFilter.maxUnit.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('maxTotal')"
      :class="{ total__contracted: headerView.contracted.maxTotal }"
      class="header total"
    >
      <div class="filtered">
        <span class="title unit">V. TOTAL</span>
        <div class="monitortotal" :style="{ top: headerView.totalTopPosition }">
          <span class="title">TOTAL</span>
          <span class="label"
            ><small>R$</small
            >{{ totalGlobal.totalCmed | CurrencyBR("0,00") }}</span
          >
        </div>
        <div
          :class="{
            dottedmenu__active: activeFilter.maxTotal.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('maxTotal')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.maxTotal"
          @close="toggleContextPopup('maxTotal', false)"
        >
          <context-text-filter
            columnId="maxTotal"
            :active-options="activeFilter.maxTotal.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header perc separator">
      <div class="filtered">
        <span class="title unit">%%</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.maxPerc.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('maxPerc')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.maxPerc"
          @close="toggleContextPopup('maxPerc', false)"
        >
          <context-text-filter
            columnId="maxPerc"
            :active-options="activeFilter.maxPerc.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>

    <!-- ESTIMATED -->
    <th
      @click="toggleColumnView('estimatedUnit')"
      :class="{ unit__contracted: headerView.contracted.estimatedUnit }"
      class="header unit"
    >
      <div class="filtered">
        <span class="title unit">V. UNIT</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.estimatedUnit.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('estimatedUnit')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.estimatedUnit"
          @close="toggleContextPopup('estimatedUnit', false)"
          position="left"
        >
          <context-field-compare
            columnId="estimatedUnit"
            :active-options="activeFilter.estimatedUnit.filterValue"
            @filter-value="filterColumn"
          />
          <context-text-filter
            columnId="estimatedUnit"
            :active-options="activeFilter.estimatedUnit.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('estimatedTotal')"
      :class="{ total__contracted: headerView.contracted.estimatedTotal }"
      class="header total"
    >
      <div class="filtered">
        <span class="title unit">V. TOTAL</span>
        <div class="monitortotal" :style="{ top: headerView.totalTopPosition }">
          <span class="title">TOTAL</span>
          <span class="label"
            ><small>R$</small
            >{{ totalGlobal.totalEstimate | CurrencyBR("0,00") }}</span
          >
        </div>
        <div
          :class="{
            dottedmenu__active: activeFilter.estimatedTotal.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('estimatedTotal')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.estimatedTotal"
          @close="toggleContextPopup('estimatedTotal', false)"
          position="left"
        >
          <context-text-filter
            columnId="estimatedTotal"
            :active-options="activeFilter.estimatedTotal.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header perc separator">
      <div class="filtered">
        <span class="title unit">%%</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.estimatedPerc.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('estimatedPerc')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.estimatedPerc"
          @close="toggleContextPopup('estimatedPerc', false)"
          position="left"
        >
          <context-text-filter
            columnId="estimatedPerc"
            :active-options="activeFilter.estimatedPerc.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>

    <!-- SALE -->
    <th
      @click="toggleColumnView('proposalUnit')"
      :class="{ unit__contracted: headerView.contracted.proposalUnit }"
      class="header unit"
    >
      <div class="filtered">
        <span class="title unit">V. UNIT</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.saleUnit.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('saleUnit')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.saleUnit"
          @close="toggleContextPopup('saleUnit', false)"
          width="460px"
          position="left"
        >
          <context-text-filter
            columnId="saleUnit"
            :active-options="activeFilter.saleUnit.filterValue"
            @filter-value="filterColumn"
          />
          <context-sale-filter />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('proposalTotal')"
      :class="{ total__contracted: headerView.contracted.proposalTotal }"
      class="header total"
    >
      <div class="filtered">
        <span class="title unit">V. TOTAL</span>
        <div class="monitortotal" :style="{ top: headerView.totalTopPosition }">
          <span class="title">TOTAL</span>
          <span class="label"
            ><small>R$</small
            >{{ totalGlobal.totalProposal | CurrencyBR("0,00") }}</span
          >
        </div>
        <div
          :class="{
            dottedmenu__active: activeFilter.saleTotal.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('saleTotal')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.saleTotal"
          @close="toggleContextPopup('saleTotal', false)"
          position="left"
        >
          <context-text-filter
            columnId="saleTotal"
            :active-options="activeFilter.saleTotal.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header perc separator">
      <div class="filtered">
        <span class="title unit">%%</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.salePerc.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('salePerc')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.salePerc"
          @close="toggleContextPopup('salePerc', false)"
          position="left"
        >
          <context-text-filter
            columnId="salePerc"
            :active-options="activeFilter.salePerc.filterValue"
            @filter-value="filterColumn"
          />
          <context-sale-perc-filter />
        </context-popup>
      </div>
    </th>

    <!-- MINIMUM -->
    <th
      @click="toggleColumnView('minimumUnit')"
      :class="{ unit__contracted: headerView.contracted.minimumUnit }"
      class="header unit"
    >
      <div class="filtered">
        <span class="title unit">V. UNIT</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.minimumUnit.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('minimumUnit')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.minimumUnit"
          @close="toggleContextPopup('minimumUnit', false)"
          position="left"
        >
          <context-text-filter
            columnId="minimumUnit"
            :active-options="activeFilter.minimumUnit.filterValue"
            @filter-value="filterColumn"
          />
          <context-minimum-filter />
        </context-popup>
      </div>
    </th>
    <th
      @click="toggleColumnView('minimumTotal')"
      :class="{ total__contracted: headerView.contracted.minimumTotal }"
      class="header total"
    >
      <div class="filtered">
        <span class="title unit">V. TOTAL</span>
        <div class="monitortotal" :style="{ top: headerView.totalTopPosition }">
          <span class="title">TOTAL</span>
          <span class="label"
            ><small>R$</small
            >{{ totalGlobal.totalMinimum | CurrencyBR("0,00") }}</span
          >
        </div>
        <div
          :class="{
            dottedmenu__active: activeFilter.minimumTotal.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('minimumTotal')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.minimumTotal"
          @close="toggleContextPopup('minimumTotal', false)"
          position="left"
        >
          <context-text-filter
            columnId="minimumTotal"
            :active-options="activeFilter.minimumTotal.filterValue"
            @filter-value="filterColumn"
          />
        </context-popup>
      </div>
    </th>
    <th class="header perc separator">
      <div class="filtered">
        <span class="title unit">%%</span>
        <div
          :class="{
            dottedmenu__active: activeFilter.minimumPerc.filterType !== '0'
          }"
          class="optionalmenu"
          @click.stop="toggleContextPopup('minimumPerc')"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          width="410px"
          v-if="visibleContextMenu.minimumPerc"
          @close="toggleContextPopup('minimumPerc', false)"
          position="left"
        >
          <context-text-filter
            columnId="minimumPerc"
            :active-options="activeFilter.minimumPerc.filterValue"
            @filter-value="filterColumn"
          />
          <context-minimum-perc-filter />
        </context-popup>
      </div>
    </th>

    <!-- Dynamic -->
    <th
      v-for="(column, columnIdx) in getDynamicColumns"
      :key="columnIdx"
      class="header"
      :class="{ [column.columnType]: true }"
    >
      <div class="filtered">
        <span class="title unit">{{ column.columnName }}</span>
        <div
          v-if="column.columnType === 'total'"
          class="monitortotal"
          :style="{ top: headerView.totalTopPosition }"
        >
          <span class="title">TOTAL</span>
          <span class="label"
            ><small>R$</small
            >{{
              totalGlobal.dynamicTotal[column.columnId] | CurrencyBR("0,00")
            }}</span
          >
        </div>
        <div
          :class="{ dottedmenu__active: activeDynamicFilter[column.columnId] }"
          class="optionalmenu"
          @click.stop="toggleContextDynmaicPopup(columnIdx)"
        >
          <icon-dotted-menu class="dottedmenu" />
        </div>
        <context-popup
          v-if="visibleContextMenu.dynamicColumn === columnIdx"
          @close="toggleContextDynmaicPopup(columnIdx)"
          width="500px"
          position="left"
        >
          <template v-if="column.columnType === 'lab'">
            <context-dynamic-lab :columnId="column.columnId" />
          </template>
          <template v-if="column.columnType === 'unit'">
            <context-text-filter
              :columnId="column.columnId"
              :active-options="activeDynamicFilter[column.columnId]"
              @clean-filter="cleanDynamicFilter"
              @filter-value="filterDynamicColumn"
            />
            <context-dynamic-vunit-filter
              :columnId="column.columnId"
              :active-options="activeDynamicFilter[column.columnId]"
              @filter-value="filterDynamicColumn"
              @close="closeAllDynamicContext"
            />
          </template>
          <template v-if="column.columnType === 'total'">
            <context-text-filter
              :columnId="column.columnId"
              :active-options="activeDynamicFilter[column.columnId]"
              @clean-filter="cleanDynamicFilter"
              @filter-value="filterDynamicColumn"
            />
          </template>
          <template v-if="column.columnType === 'perc'">
            <context-text-filter
              :columnId="column.columnId"
              :active-options="activeDynamicFilter[column.columnId]"
              @clean-filter="cleanDynamicFilter"
              @filter-value="filterDynamicColumn"
            />
          </template>
        </context-popup>
      </div>
    </th>
  </tr>
</template>

<script>
import { IconDottedMenu, IconStar } from "@/components/primitives/icons";
import { ContextPopup } from "@/components/primitives";
import ContextListFilter from "../context-list-filter/ContextListFilter";
import ContextTextFilter from "../context-text-filter/ContextTextFilter";
import QuotesMapContextFilter from "../context-quotesmap-filter/QuotesMapContextFilter";
import ContextMeFilter from "../context-me-filter/ContextMeFilter";
import ContextFieldCompare from "../context-field-compare/ContextFieldCompare";
import ContextGuarantedFilter from "../context-guaranted-filter/ContextGuarantedFilter";
import ContextMinimumFilter from "../context-minimum-filter/ContextMinimumFilter";
import ContextMinimumPercFilter from "../context-minimum-perc-filter/ContextMinimumPercFilter";
import ContextSaleFilter from "../context-sale-filter/ContextSaleFilter";
import ContextSalePercFilter from "../context-sale-perc-filter/ContextSalePercFilter";
import ContextDynamicVunitFilter from "../context-dynamic-vunit-filter/ContextDynamicVunitFilter";
import ContextDynamicLab from "../context-dynamic-lab/ContextDynamicLab";
import { CurrencyBR } from "@/components/primitives/helpers/filters";

import { mapGetters } from "vuex";

let elementScroll = null;
let elementTable = null;

export default {
  name: "ColumnHeader",
  components: {
    IconDottedMenu,
    ContextPopup,
    ContextListFilter,
    ContextTextFilter,
    QuotesMapContextFilter,
    ContextMeFilter,
    ContextGuarantedFilter,
    ContextMinimumFilter,
    ContextMinimumPercFilter,
    ContextSaleFilter,
    ContextSalePercFilter,
    ContextDynamicVunitFilter,
    IconStar,
    ContextFieldCompare,
    ContextDynamicLab
  },
  props: {
    activeFilter: {
      default: () => ({})
    },
    activeDynamicFilter: {
      default: () => ({})
    }
  },
  data: () => ({
    headerView: {
      totalTopPosition: "100px",
      contracted: {
        costLab: false,
        costUnit: false,
        costTotal: false,
        maxLab: false,
        maxUnit: false,
        maxTotal: false,
        estimatedLab: false,
        estimatedUnit: false,
        estimatedTotal: false,
        proposalUnit: false,
        proposalTotal: false,
        minimumUnit: false,
        minimumTotal: false,
        rankingDistributor: false,
        rankingLab: false,
        rankingUnit: false,
        rankingTotal: false
      }
    },
    columnEdition: {
      costLab: {
        id: "costLab",
        label: "Custo - Marca"
      },
      costUnit: {
        id: "costUnit",
        label: "Custo - Valor Unitário"
      },
      costTotal: {
        id: "costTotal",
        label: "Custo - Valor Total"
      },
      maxLab: {
        id: "maxLab",
        label: "Máximo - Marca"
      },
      maxUnit: {
        id: "maxUnit",
        label: "Máximo - Valor Unitário"
      },
      maxTotal: {
        id: "maxTotal",
        label: "Máximo - Valor Total"
      },
      maxPerc: {
        id: "maxPerc",
        label: "Máximo - Percentual"
      },
      estimatedUnit: {
        id: "estimatedUnit",
        label: "Estimado - Valor Unitário"
      },
      estimatedTotal: {
        id: "estimatedTotal",
        label: "Estimado - Valor Total"
      },
      estimatedPerc: {
        id: "estimatedPerc",
        label: "Estimado - Percentual"
      },
      saleUnit: {
        id: "saleUnit",
        label: "Venda - Valor Unitário"
      },
      saleTotal: {
        id: "saleTotal",
        label: "Venda - Valor Total"
      },
      salePerc: {
        id: "salePerc",
        label: "Venda - Percentual"
      },
      minimumUnit: {
        id: "minimumUnit",
        label: "Mínimo - Valor Unitário"
      },
      minimumTotal: {
        id: "minimumTotal",
        label: "Mínimo - Valor Total"
      },
      minimumPerc: {
        id: "minimumPerc",
        label: "Mínimo - Percentual"
      }
    },
    visibleContextMenu: {
      number: false,
      quotationMap: false,
      strictToME: false,
      isPriceGuaranted: false,
      description: false,
      unity: false,
      costLab: false,
      costUnit: false,
      costTotal: false,
      maxLab: false,
      maxUnit: false,
      maxTotal: false,
      maxPerc: false,
      estimatedUnit: false,
      estimatedTotal: false,
      estimatedPerc: false,
      saleUnit: false,
      saleTotal: false,
      salePerc: false,
      minimumUnit: false,
      minimumTotal: false,
      minimumPerc: false,
      dynamicColumn: null
    }
  }),
  filters: {
    CurrencyBR
  },
  computed: {
    ...mapGetters({
      getDynamicColumns: "ItemPricing/GET_DYNAMIC_COLUMNS",
      totalGlobal: "ItemPricing/GET_TOTAL_GLOBAL"
    })
  },
  watch: {
    "headerView.contracted": {
      handler(v) {
        this.$emit("header-view-contraction", v);
      },
      deep: true
    }
  },
  mounted() {
    elementScroll = document.querySelector(".list-container");
    elementTable = document.querySelector(".list-container > table");
    elementScroll.addEventListener("scroll", this.handleTableScrollY);

    this.handleTableScrollY();
  },
  beforeUnmount() {
    elementScroll.removeEventListener("scroll", this.handleTableScrollY);
  },
  methods: {
    handleTableScrollY() {
      const showOnTop =
        elementScroll.scrollTop + elementScroll.clientHeight ===
        elementTable.clientHeight;
      const screenHeight = window.innerHeight - 140;
      const topPosition = "25px";
      const bottomPosition = `${screenHeight}px`;
      if (showOnTop && this.headerView.totalTopPosition !== topPosition) {
        this.headerView.totalTopPosition = topPosition;
      } else if (
        !showOnTop &&
        this.headerView.totalTopPosition !== bottomPosition
      ) {
        this.headerView.totalTopPosition = bottomPosition;
      }
    },
    toggleColumnView(column) {
      this.headerView.contracted[column] = !this.headerView.contracted[column];
    },
    toggleAllColumn(columns) {
      const newState = !this.headerView.contracted[columns[0]];
      for (const column in columns) {
        this.headerView.contracted[columns[column]] = newState;
      }
    },
    openColumnEdition(column) {
      this.$emit("open-edition", column);
    },
    toggleContextPopup(contextMenu, defaultValue = undefined) {
      const newContextMenu = {};
      for (const ctxMenu in this.visibleContextMenu) {
        newContextMenu[ctxMenu] =
          ctxMenu === contextMenu
            ? defaultValue || !this.visibleContextMenu[contextMenu]
            : false;
      }
      this.visibleContextMenu = {
        ...this.visibleContextMenu,
        ...newContextMenu
      };
    },
    toggleContextDynmaicPopup(dynamicColumnsIdx) {
      if (this.visibleContextMenu.dynamicColumn === dynamicColumnsIdx) {
        this.toggleContextPopup(null, false);
      } else {
        this.toggleContextPopup(null, false);
        this.visibleContextMenu.dynamicColumn = dynamicColumnsIdx;
      }
    },
    closeAllContext() {
      const newContextMenu = {};
      for (const ctxMenu in this.visibleContextMenu) {
        newContextMenu[ctxMenu] = false;
      }
      this.visibleContextMenu = newContextMenu;
    },
    closeAllDynamicContext() {
      this.visibleContextMenu.dynamicColumn = null;
    },
    filterColumn(filters) {
      this.$emit("filter-value", filters);
      this.closeAllContext();
    },
    filterDynamicColumn(filters) {
      this.$emit("filter-dynamic-value", filters);
      this.closeAllDynamicContext();
    },
    cleanFilter({ columnId }) {
      this.filterColumn({
        columnId,
        filterType: "0",
        filterValue: null
      });
    },
    cleanDynamicFilter({ columnId }) {
      this.$emit("filter-dynamic-value", {
        columnId,
        filterType: "0",
        filterValue: null
      });
      this.closeAllDynamicContext();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/column-header/ColumnHeader.vue